export default "/048cb1f2b29308e18768c65cfd51e426596a830c/11a14d9b63ec892bb84cea8c67204259.svg";